import React from "react";
import { Link } from "react-scroll";
import Typewriter from "typewriter-effect";
import { scrollDuration } from "../../../config/commonConfig";

const BottomHeaderDefaultIntro = () => {
  return (
    <section
      id="home"
      className="bg-primary d-flex flex-column fullscreen py-5 position-relative"
    >
      <div className="container my-auto">
        <div className="row">
          <div className="col-lg-10 mx-auto text-center">
            <div className="bg-white shadow rounded-pill p-2 mb-4 d-inline-block wow zoomIn">
              <img
                className="img-fluid rounded-pill d-block"
                src="images/kasun-profile-265x265.jpg"
                title="I'm Kasun"
                alt="Kasun"
              />
            </div>
            <h1 className="text-12 fw-300 mb-0">
              KASUN DE SILVA
            </h1>
            <h2 className="text-10 fw-600 mb-4 wow fadeInUp">
            <Typewriter
                options={{
                  strings: ["Cloud Architect", "DevOps Enabler", "AWS Community Builder",],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h2>
            <p className="text-5 pb-3 wow fadeInUp">
              based in Wellington, NZ.
            </p>
            <Link
              className="btn btn-dark rounded-0 smooth-scroll wow fadeInUp"
              smooth="easeInOutQuint"
              duration={scrollDuration}
              style={{ cursor: "pointer" }}
              to="about"
            >
              About Me
            </Link>
          </div>
        </div>
      </div>
      <div className="container py-2 text-center">
        <Link
          className="scroll-down-arrow text-dark smooth-scroll"
          smooth="easeInOutQuint"
          duration={scrollDuration}
          style={{ cursor: "pointer" }}
          to="about"
        >
          <span className="animated">
            <i className="fas fa-arrow-down" />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default BottomHeaderDefaultIntro;
